export class ARInvoiceWriteOffParameterDto {
    writeOffDescription: string; // Required
    communityId: number;
    managementCompanyId: number;
    invoiceId: number; // Required
    clearCache: boolean;
}
